import type { MachineFamily, TelemetryData } from "@strtmn/sds/types"
import { I18n } from "aws-amplify/utils"
import { isProd } from "../../config"
import { findTelemetryItem } from "../vehicle-overview/DashboardUtils"

function getVersionInfo(
  telemetryData: TelemetryData,
  pgnSource: string,
  prefix: string
): string | undefined {
  const major = findTelemetryItem(telemetryData, [
    `${pgnSource}/${prefix}Maj`,
  ])?.Value
  const minor = findTelemetryItem(telemetryData, [
    `${pgnSource}/${prefix}Min`,
  ])?.Value
  const patch = findTelemetryItem(telemetryData, [
    `${pgnSource}/${prefix}Pat`,
  ])?.Value

  if (major === undefined || minor === undefined || patch === undefined) {
    return undefined
  }

  const hardwareRevision = findTelemetryItem(telemetryData, [
    `${pgnSource}/${prefix}Har`,
  ])?.Value
  return hardwareRevision === undefined
    ? `${major}.${minor}.${patch}`
    : `${major}.${minor}.${patch} (HW ${hardwareRevision})`
}

interface SoftwareVersionsProps {
  telemetryData: TelemetryData
  machineFamily?: MachineFamily
  modemSerial?: string
}

export default function SoftwareVersions({
  machineFamily,
  telemetryData,
  modemSerial,
}: SoftwareVersionsProps) {
  !isProd && console.log("SoftwareVersions: machineFamily =", machineFamily)

  const versionMai = getVersionInfo(
    telemetryData,
    `${0xd4f3}@${0x00b3}`,
    "VersMai"
  )
  const versionDis = getVersionInfo(
    telemetryData,
    `${0xd4f3}@${0x00b3}`,
    "VersDis"
  )
  const versionLib = getVersionInfo(
    telemetryData,
    `${0xd4f3}@${0x00b3}`,
    "VersLib"
  )
  const versionModem = getVersionInfo(
    telemetryData,
    `${0x0000}@${0x0035}`,
    "Modem"
  )

  const versions = []
  if (machineFamily !== "e-vertifeed") {
    // eVF reports only "Dis" version.
    versions.push(
      `${I18n.get("Steuerung")}: ${versionMai ?? I18n.get("nicht verfügbar")}`
    )
  }
  versions.push(
    `${I18n.get("Display")}: ${versionDis ?? I18n.get("nicht verfügbar")}`
  )
  versions.push(
    `${I18n.get("Lib")}: ${versionLib ?? I18n.get("nicht verfügbar")}`
  )
  versions.push(
    `${I18n.get("Modem")}: ${versionModem ?? I18n.get("nicht verfügbar")}`
  )
  if (modemSerial) {
    versions.push(`${I18n.get("Modem S/N")}: ${modemSerial}`)
  }
  // Fernwartung

  return (
    <>
      <h2>Software Versionen</h2>
      <div>{versions.join(", ")}</div>
    </>
  )
}
